import {
  Button,
  Card,
  CardBody,
  Col,
  CardTitle,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React from "react";
import Select from "react-select";
import NkHeader from "../../common/nkheader";
import Loading from "../loader/loader";

const Billingandmappingpresentational = ({
  setShowPopupModal,
  handleChange,
  category,
  temp,
  handleSearch,
  subcategory,
  setFilterForm,
  filterform,
  dataloading,
  setButtonDisable,
  buutonDiasble,
  categorydataloading,
}) => {
  return (
    <>
      <Container fluid>
        <NkHeader title="Biller Viewing and Mapping" />
        <Card>
          <CardBody>
            <Row>
              <Col>
                {!categorydataloading ? (
                  <Select
                    closeMenuOnSelect={true}
                    placeholder="Search Category"
                    // isLoading={!categorydataloading}
                    onChange={(data) => {
                      handleChange(data);
                    }}
                    options={category}
                  ></Select>
                ) : (
                  <Loading color="white" width="15px" height="15px" />
                )}
              </Col>
              <Col style={{ display: "flex", alignItems: "center" }}>
                {" "}
                <div>
                  <Button
                    style={{ width: "100px", height: "26px" }}
                    color="primary"
                    type="button"
                    id="example3cols2Input"
                    className="filter-button-beneficiery"
                    onClick={handleSearch}
                  >
                    <div>
                      <i className="fas fa-search"></i>
                      <span>
                        {" "}
                        {dataloading ? (
                          <Loading color="white" width="15px" height="15px" />
                        ) : (
                          "Search"
                        )}
                      </span>
                    </div>
                  </Button>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card style={{ marginTop: "30px" }}>
          <CardBody>
            <CardTitle tag="h1" className="user-verification-header">
              Paykii Category
            </CardTitle>
            <Container
              style={{
                maxHeight: "250px",
                overflowY: "scroll",
                width: "410px",
              }}
            >
              {subcategory.length > 0 ? (
                subcategory.map((item, index) => (
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        key={temp + subcategory + "_" + index}
                        value={item.subCategoryId}
                        onClick={(e) => {
                          if (e.target.checked) {
                            setFilterForm([
                              ...filterform,
                              {
                                subCategoryId: item.subCategoryId,
                              },
                            ]);
                            setButtonDisable(false);
                          } else {
                            setFilterForm(
                              filterform.filter(
                                (data) =>
                                  data.subCategoryId !== item.subCategoryId
                              )
                            );
                            filterform.length <= 1 && setButtonDisable(true);
                          }
                        }}
                      />
                      {item.subCategoryName}
                    </Label>
                  </FormGroup>
                ))
              ) : (
                <h2> No Categories</h2>
              )}
            </Container>
            <Row
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "20px",
              }}
            >
              <Button
                color="primary"
                disabled={buutonDiasble}
                onClick={() => {
                  setShowPopupModal(true);
                  setButtonDisable(true);
                }}
              >
                Map Category
              </Button>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Billingandmappingpresentational;
